import { Nullable, SupportedSearchParam } from "@utils/types";

import { getSupportedSearchParamFromUrl } from "./getSupportedSearchParamFromUrl";

export const getCMIDfromQuery = (): Nullable<string> => getSupportedSearchParamFromUrl(SupportedSearchParam.cmid);
